import { render, staticRenderFns } from "./FarmFireRiskChartCard.vue?vue&type=template&id=3a9bc204&scoped=true"
import script from "./FarmFireRiskChartCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./FarmFireRiskChartCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FarmFireRiskChartCard.vue?vue&type=style&index=0&id=3a9bc204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9bc204",
  null
  
)

export default component.exports